module.exports = __webpack_public_path__ + "img/ecp.e23c93ea.jpeg";